import UpdateWrap from "./update-wrap";

export default UpdateWrap;